module.exports = __webpack_public_path__ + "static/img/1.2d43776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/1.png
// module id = 4Shk
// module chunks = 0